import { initReactI18next } from 'react-i18next'
import en from 'assets/i18n/en.json'
import i18n from 'i18next'

i18n.use(initReactI18next).init({
  resources: {
    en,
  },
  defaultNS: 'common',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})
